import { createWebHistory, createRouter } from 'vue-router';
import Public from '../views/public/public';
import Private from '../views/private/private';
import {PublicRoutes} from '../views/public/router';
import {PrivateRoutes} from '../views/private/router';

const routes = [
  {
    path: '',
    component: Private,
    children: PrivateRoutes,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/public',
    component: Public,
    children: PublicRoutes,
    meta: {
      requiresAuth: false
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes: routes
})

export default router
